import { createHtmlRenderState } from "../../html/utils/create-render-state";
export const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});
//# sourceMappingURL=create-render-state.js.map